import React from 'react'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { usePage } from 'client/store/index'
import pageSelectors from 'client/store/page/pageSelectors'
import DeviceAppearanceNew from '../../options/DeviceAppearance/DeviceAppearanceNew'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'

interface PriceElementSettingsProps {
  entity: PriceElementInterface
}

export const PriceElementSettings = ({ entity }: PriceElementSettingsProps) => {
  const { isMobile } = useDeviceModeContext()

  const popups = usePage(pageSelectors.getWebsiteGlobalOrPagePopupEntities)(entity)

  const updateProp = useUpdateProp(entity)

  const popupChoiceList = popups.reduce(
    (acc, popup) => ({
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      [popup.id]:
        popup.type === EntityTypeEnum.Popup ? popup.title : popup.options.title,
    }),
    {},
  )

  return (
    <>
      <GroupTitle isFirst>Popups</GroupTitle>
      <Select
        labelText="First plan"
        update={updateProp('popupIdFirstPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdFirstPlan}
        skipTranslation
      />
      <Select
        labelText="Second plan"
        update={updateProp('popupIdSecondPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdSecondPlan}
        skipTranslation
      />
      <Select
        labelText="Third plan"
        update={updateProp('popupIdThirdPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdThirdPlan}
        skipTranslation
      />
      <Select
        labelText="Fourth plan"
        update={updateProp('popupIdFourthPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdFourthPlan}
        skipTranslation
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
